function transformToNewFormat(oldData, fallbackData = {}, listingType = null) {
  const address = oldData?.addressDetails || {};
  const receiverDetails = oldData?.userDetailsDto?.receiverDetails?.[0] || {};
  const companyId =
    oldData?.companyId ||
    JSON.parse(localStorage.getItem("selectedCompany"))?.newCompanyId;

  const getValue = (primary, fallback) => {
    if (primary !== undefined && primary !== null && primary !== "") {
      return primary;
    } else if (fallback !== undefined && fallback !== null) {
      return fallback;
    } else {
      return null;
    }
  };

  const oldChildData = oldData?.childShipments?.map((item) => ({
    documentNo: String(item?.childDocumentNumber),
    value: 0,
    dwsWeight: +item?.weight || 0,
    dwsLength: +item?.length || 0,
    dwsWidth: +item?.width || 0,
    dwsHeight: +item?.height || 0,
  }));

  const oldeWayBills = oldData?.ewayBills?.map((bill) => ({
    eway: bill?.ewayBillNumber,
    date: null,
    eway_bill_crt_date: bill?.ewayBillCreateDate,
    ewb_bill_exp_date: bill?.expiryDate,
    trans_mode:
      bill?.transMode?.toLowerCase() === "road"
        ? "surface"
        : bill?.transMode?.toLowerCase(),
    name: "",
  }));

  const omitKeys = (obj, keys = []) =>
    Object.fromEntries(
      Object.entries(obj || {}).filter(([key]) => !keys.includes(key))
    );
  const cleanedCharges = omitKeys(fallbackData?.charges, [
    "createdAt",
    "updatedAt",
    "id",
  ]);

  return {
    documentNo: getValue(oldData.documentNumber, fallbackData?.documentNo),
    isBulk: getValue(false, fallbackData?.isBulk),
    bookingType: getValue(
      receiverDetails.bookingType?.toLowerCase() === "account"
        ? "credit"
        : "retail",
      fallbackData?.bookingType
    ),
    areaId: getValue(oldData.areaId, fallbackData?.areaId),
    status: "BOOKED",
    shipmentType: getValue(oldData.shipmentType, fallbackData?.shipmentType),
    travelBy: getValue(oldData.travelBy, fallbackData?.travelBy),
    deliveryPromise: fallbackData?.deliveryPromise || oldData?.service,
    clientId: getValue(oldData.clientId, fallbackData?.clientId),
    companyId: getValue(companyId, fallbackData?.companyId),
    dwsWeight: getValue(Number(oldData.weight), fallbackData?.dwsWeight),
    dwsLength: getValue(oldData.length, fallbackData?.dwsLength),
    dwsWidth: getValue(oldData.width, fallbackData?.dwsWidth),
    dwsHeight: getValue(oldData.height, fallbackData?.dwsHeight),
    username: getValue(oldData.username, fallbackData?.username),

    pickupAddress: {
      addressType: "pickup",
      name: getValue(
        oldData?.addressDetails?.senderName,
        fallbackData?.pickupAddress?.name
      ),
      email: getValue(
        oldData?.addressDetails?.senderEmail,
        fallbackData?.pickupAddress?.email
      ),
      gst: getValue(oldData.senderGstNumber, fallbackData?.pickupAddress?.gst),
      phone: getValue(
        oldData?.addressDetails?.senderMobileNumber,
        fallbackData?.pickupAddress?.phone
      ),
      address1: getValue(
        address.senderAddressLine1,
        fallbackData?.pickupAddress?.address1
      ),
      address2: getValue(
        address.senderAddressLine2,
        fallbackData?.pickupAddress?.address2
      ),
      landmark: getValue(null, fallbackData?.pickupAddress?.landmark),
      city: getValue(address.senderCity, fallbackData?.pickupAddress?.city),
      state: getValue(address.senderState, fallbackData?.pickupAddress?.state),
      country: getValue(null, fallbackData?.pickupAddress?.country),
      zip: getValue(
        String(address.senderPincode || ""),
        fallbackData?.pickupAddress?.zip
      ),
      latitude: getValue(null, fallbackData?.pickupAddress?.latitude),
      longitude: getValue(null, fallbackData?.pickupAddress?.longitude),
    },

    receiverAddress: {
      addressType: "shipping",
      name: getValue(
        address.receiverName || receiverDetails.name,
        fallbackData?.receiverAddress?.name
      ),
      email: getValue(
        address.receiverEmail || receiverDetails.emailAddress,
        fallbackData?.receiverAddress?.email
      ),
      gst: getValue(null, fallbackData?.receiverAddress?.gst),
      phone: getValue(
        String(
          address.receiverMobileNumber || receiverDetails.mobileNumber || ""
        ),
        fallbackData?.receiverAddress?.phone
      ),
      address1: getValue(
        address.receiverAddressLine1 || receiverDetails.address,
        fallbackData?.receiverAddress?.address1
      ),
      address2: getValue(
        address.receiverAddressLine2,
        fallbackData?.receiverAddress?.address2
      ),
      landmark: getValue(null, fallbackData?.receiverAddress?.landmark),
      city: getValue(address.receiverCity, fallbackData?.receiverAddress?.city),
      state: getValue(
        address.receiverState,
        fallbackData?.receiverAddress?.state
      ),
      country: getValue(null, fallbackData?.receiverAddress?.country),
      zip: getValue(
        String(address.receiverPincode || ""),
        fallbackData?.receiverAddress?.zip
      ),
      latitude: getValue(null, fallbackData?.receiverAddress?.latitude),
      longitude: getValue(null, fallbackData?.receiverAddress?.longitude),
    },

    returnAddress: {
      addressType: "return",
      name: getValue(
        oldData?.addressDetails?.senderName,
        fallbackData?.pickupAddress?.name
      ),
      email: getValue(
        oldData?.addressDetails?.senderEmail,
        fallbackData?.pickupAddress?.email
      ),
      gst: getValue(oldData?.senderGstNumber, fallbackData?.pickupAddress?.gst),
      phone: getValue(
        oldData?.addressDetails?.senderMobileNumber,
        fallbackData?.pickupAddress?.phone
      ),
      address1: getValue(
        oldData?.addressDetails?.senderAddressLine1,
        fallbackData?.pickupAddress?.address1
      ),
      address2: getValue(
        oldData?.addressDetails?.senderAddressLine2,
        fallbackData?.pickupAddress?.address2
      ),
      landmark: getValue(null, fallbackData?.pickupAddress?.landmark),
      city: getValue(
        oldData?.addressDetails?.senderCity,
        fallbackData?.pickupAddress?.city
      ),
      state: getValue(
        oldData?.addressDetails?.senderState,
        fallbackData?.pickupAddress?.state
      ),
      country: getValue(null, fallbackData?.pickupAddress?.country),
      zip: getValue(
        String(oldData?.addressDetails?.senderPincode || ""),
        fallbackData?.pickupAddress?.zip
      ),
      latitude: getValue(null, fallbackData?.pickupAddress?.latitude),
      longitude: getValue(null, fallbackData?.pickupAddress?.longitude),
    },

    childShipments: getValue(oldChildData, fallbackData?.childShipments) || [],

    charges: cleanedCharges,

    cod: getValue(null, fallbackData?.cod),
    pod: getValue(null, fallbackData?.pod),

    metadata: {
      value: +getValue(oldData.value, fallbackData?.metadata?.value),
      content: getValue(oldData.content, fallbackData?.metadata?.content),
      remark: getValue(oldData.description, fallbackData?.metadata?.remark),
      insured: getValue(oldData.insured, fallbackData?.metadata?.insured),
      fov: getValue(false, fallbackData?.metadata?.fov),
      isSez: getValue(false, fallbackData?.metadata?.isSez),
      kycDocumentNo: getValue(null, fallbackData?.metadata?.kycDocumentNo),
      kycDocumentType: getValue(null, fallbackData?.metadata?.kycDocumentType),
      utm: getValue(
        listingType == "API" ? "API" : "OCR",
        fallbackData?.metadata?.utm
      ),
      refDocumentNo: getValue(null, fallbackData?.metadata?.refDocumentNo),
    },

    documents: getValue(oldData.files, fallbackData?.documents) || [],
    eWayBills: getValue(oldeWayBills, fallbackData?.eWayBills) || [],
  };
}

export default transformToNewFormat;
